import script from "./MobileDrawsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileDrawsSection.vue?vue&type=script&setup=true&lang=ts"

import "./MobileDrawsSection.vue?vue&type=style&index=0&id=1557d045&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1557d045"]])

export default __exports__